import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "category_layout"
};
const _hoisted_2 = {
  class: "title"
};
const _hoisted_3 = {
  class: "category_list"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "operation_layout"
};

const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "分类操作", -1);

import { ref, watch, computed } from "vue";
import useRoute from "@util/router";
import useAccoutStore from "@store/accout";
export default {
  __name: 'CategoryView',
  props: ['title', 'data'],
  emits: ['modify', 'del', 'add', 'change'],

  setup(__props) {
    const accoutStore = useAccoutStore();
    const route = useRoute();
    const props = __props;
    const searchName = ref('');
    const showData = ref(props.data);
    const activeCode = ref(route.query().c || props.data[0].code);
    const modifyMode = computed(() => {
      return accoutStore.userInfo.mainStore;
    });
    watch(() => searchName.value, val => {
      search(val);
    });
    watch(() => props.data, val => {
      showData.value = val;

      if (val.find(e => {
        return e.code == activeCode.value;
      }) == null) {
        activeCode.value = 'all';
      }
    });

    function search(key) {
      if (key != null && key.length > 0) {
        let result = [];

        for (let item of props.data) {
          if (item.name.length > 0 && item.name.includes(key)) {
            result.push(item);
          }
        }

        showData.value = result;
      } else {
        showData.value = props.data;
      }
    }

    function switchCategory(data) {
      if (data.code != activeCode.value) {
        activeCode.value = data.code;
        route.replaceQuery('c', data.code);
      }
    }

    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      const _component_el_input = _resolveComponent("el-input");

      const _component_Operation = _resolveComponent("Operation");

      const _component_el_icon = _resolveComponent("el-icon");

      const _component_el_popover = _resolveComponent("el-popover");

      const _directive_auth = _resolveDirective("auth");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("b", null, _toDisplayString(__props.title), 1)]), modifyMode.value ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        size: "small",
        type: "primary",
        onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('add', _ctx.item))
      }, {
        default: _withCtx(() => [_createTextVNode("添加分类")]),
        _: 1
      })), [[_directive_auth, _ctx.getCurCode('CATEGORYADD')]]) : _createCommentVNode("", true), _createVNode(_component_el_input, {
        class: "search",
        modelValue: searchName.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => searchName.value = $event),
        placeholder: "查找分类",
        clearable: ""
      }, null, 8, ["modelValue"]), _createElementVNode("ul", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(showData.value, (item, index) => {
        return _openBlock(), _createElementBlock("li", {
          key: index,
          class: _normalizeClass({
            active: item.code == activeCode.value
          }),
          onClick: $event => switchCategory(item)
        }, [_createElementVNode("span", null, _toDisplayString(item.name), 1), item.name != '全部' && modifyMode.value ? (_openBlock(), _createBlock(_component_el_popover, {
          key: 0,
          placement: "bottom",
          width: 100
        }, {
          reference: _withCtx(() => [_createVNode(_component_el_icon, {
            class: "operation_icon",
            size: 16
          }, {
            default: _withCtx(() => [_createVNode(_component_Operation)]),
            _: 1
          })]),
          default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", null, [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "r_m_10",
            size: "small",
            onClick: $event => _ctx.$emit('modify', item)
          }, {
            default: _withCtx(() => [_createTextVNode("编辑")]),
            _: 2
          }, 1032, ["onClick"])), [[_directive_auth, _ctx.getCurCode('CATEGORYMODIFY')]]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            size: "small",
            onClick: $event => _ctx.$emit('del', item)
          }, {
            default: _withCtx(() => [_createTextVNode("删除")]),
            _: 2
          }, 1032, ["onClick"])), [[_directive_auth, _ctx.getCurCode('CATEGORYDELETE')]])])])]),
          _: 2
        }, 1024)) : _createCommentVNode("", true)], 10, _hoisted_4);
      }), 128))])]);
    };
  }

};